import { api } from './client';
import type { AgentDto } from './types';

export function listAgents(): Promise<AgentDto[]> {
  return api.get<AgentDto[]>('/api/v1/agents');
}

export function getAgent(id: string): Promise<AgentDto> {
  return api.get<AgentDto>(`/api/v1/agents/${id}`);
}

export interface AgentBody {
  name: string;
  persona_id?: string | null;
  scenario_id?: string | null;
  model_config?: Record<string, unknown> | null;
  channel_ids?: string[];
}

export function createAgent(body: AgentBody): Promise<AgentDto> {
  return api.post<AgentDto>('/api/v1/agents', body);
}

export function patchAgent(id: string, body: Partial<AgentBody>): Promise<AgentDto> {
  return api.patch<AgentDto>(`/api/v1/agents/${id}`, body);
}

export function enableAgent(id: string): Promise<AgentDto> {
  return api.post<AgentDto>(`/api/v1/agents/${id}/enable`);
}

export function disableAgent(id: string): Promise<AgentDto> {
  return api.post<AgentDto>(`/api/v1/agents/${id}/disable`);
}
